import {register} from '../../../assets/js/modules/eventMap';

const init = (el) => {
    if (!el) {
        return;
    }

    // Add key event handler for `SPACE` key
    el.addEventListener('keydown', (event) => {
        if (event.key === ' ') {
            event.preventDefault(); // Prevent default scrolling behavior for SPACE
            el.click(); // Simulate a click event
        }
    });
};

const addLinkButtonKeyboardSupport = () => {
    register('addLinkButtonKeyboardSupport', {init});
};

export {addLinkButtonKeyboardSupport};
